import React from "react";

/**
 * Small metric card for dashboards / summaries
 */

const SummaryCard = ({ label, value }) => {
  return (
    <div className="bg-gray-50 p-4 rounded-xl border border-gray-200">
      <div className="text-xs text-gray-500">{label}</div>
      <div className="text-lg font-semibold text-gray-800">
        {value}
      </div>
    </div>
  );
};

export default SummaryCard;